import type {
    EventType as IEventType,
    EventOptions as IEventOptions,
    DangerCunstomEventOption
} from '@/types/event';

export const oldApiTransformer = <T extends IEventType>(
    type: T | { type: T },
    name: string | IEventOptions<T> = {},
    params?: any,
    contentPackage?: {[key: string]: any} | string
): [T, IEventOptions<T>] => {
    let realType: T;
    if (typeof type !== 'string') {
        realType = type.type;
    }
    realType = (type as T).toUpperCase() as T;
    let options: any = {};
    if (typeof name === 'string') {
        console.warn('[warn 105]', '接口参数为旧式，后续版本将不再兼容，推荐使用新的参数形式');
        options.contentPackage = contentPackage;
        if (type === 'CUSTOM') {
            options.key = name;
            options.value = params;
        } else {
            options.params = params;
            if (type === 'PV') {
                options.page = name;
            }else {
                options.action = name;
            }
        }
    } else {
        options = name;
        if (['CUSTOM', 'CUSTOM_EVENT'].includes(realType)) {
            const customParams = name as DangerCunstomEventOption & { key?: string; value?: any };
            if (customParams.action && !customParams.key) {
                options.key = customParams.action;
            }
            if (customParams.params && !customParams.value) {
                options.value = customParams.params;
            }
        }
    }
    return [
        realType,
        options
    ];
};